import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import ModalAddKiosk from "screens/ModalAddKiosk";
import Slider from "./Slider";
import { useQuery } from "@apollo/client";
import { GET_ALL_KIOSKS } from "graphql/service";
import { Content, CouponTableContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";
import { RemoveIcon, EditIcon } from "assets/icons";

const Devices = () => {

  const [kiosks, setKiosks] = useState([]);

  const { data: kiosksData, error } = useQuery(GET_ALL_KIOSKS);

  useEffect(() => {
    if (kiosksData) {
      setKiosks(kiosksData.kiosks);
    }
  }, [kiosksData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  const kioskArray = kiosks.map((kiosk, index) => {
    return (
      <tr key={index}>
        <td className="deviceName">{kiosk.username}</td>
        <td className="paymentTerminal">{kiosk.devices?.find((device) => device.type === "PAYMENT_TERMINAL")?.name}</td>
        <td className="passportScanner">{kiosk.devices?.find((device) => device.type === "PASSPORT_SCANNER")?.name}</td>
        <td className="keycardDispenser">{kiosk.devices?.find((device) => device.type === "KEYCARD_DISPENSER")?.name}</td>
        <td className="onOff">
          <Slider
            checked={!kiosk.isDeleted}
            kioskId={kiosk.kioskId}
            setKiosks={setKiosks}
          />
        </td>
        <td className="action">
          <span className="edit">
            <EditIcon /> Edit
          </span>
          <span className="delete">
            <RemoveIcon /> Remove
          </span>
        </td>
      </tr>
    );
  });

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="type">CURRENT DEVICES</div>
        <div className="buttonContainer">
          <ModalAddKiosk
            buttonStyle={`
              width: 134px;
            `}
            setKiosks={setKiosks}
          />
        </div>
      </CardHeader>
      <Content>
        {kioskArray.length === 0 ? (
          <div className="noDevice">
            There are no kiosks available. Please use 'Add New Kiosk' to create one.
          </div>
        ) : (
          <>
            <div className="deviceDescription">
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. culpa qui officia
              deserunt mollierunt mollie.”
            </div>
            <CouponTableContainer>
              <thead>
                <tr>
                  <th className="deviceName">KIOSK NAME</th>
                  <th className="paymentTerminal">PAYMENT TERMINAL</th>
                  <th className="passportScanner">PASSPORT SCANNER</th>
                  <th className="keycardDispenser">KEYCARD DISPENSER</th>
                  <th className="onOff">ON/OFF</th>
                  <th className="action">ACTION</th>
                </tr>
              </thead>
              <tbody>{kioskArray}</tbody>
            </CouponTableContainer>
          </>
        )}
      </Content>
    </Card>
  );
};

export default Devices;
